import React, {Fragment} from 'react';

import {HealthProfessionalSelectionProps} from './types';
import {useHealthProfessionalSelection} from './hooks/useHealthProfessionalSelection';
import {BookingLoadingState} from 'presentation/modules/booking/shared/ui/components/BookingLoadingState';
import {translations} from 'presentation/translations-new';
import {BookingErrorState} from 'presentation/modules/booking/shared/ui/components/BookingErrorState';
import {HealthProfessionalSelectionNotFoundState} from './components/HealthProfessionalSelectionNotFoundState';
import {AppointmentBookingEnum, FinishWithoutCompleteFlowEnum} from 'main/analytics/gaTagsEnum';
import {HealthSelectedDateProfessionalList} from './components/HealthSelectedDateProfessionalList';
import {HealthNearestDateProfessionalList} from './components/HealthNearestDateProfessionalList';
import {AlertActions, AlertModal} from 'presentation/components';
import {PendingDialog} from 'presentation/modules/booking/shared/ui/components/PendingDialog';

const {bookHealth} = translations['pt-br'].privateFlow.services;
const {loadingState, loadingError, searchBestOptionModal} =
	translations['pt-br'].privateFlow.bookingFlow.professionalFlow;

export function HealthProfessionalSelection({handleNextStep}: HealthProfessionalSelectionProps) {
	const {
		isLoading,
		refetch,
		isError,
		showNotFoundState,
		handleSelectHour,
		showSelectedDateProfessionalGrid,
		handleClearShiftAndSearch,
		availableDates,
		filteredProvidersNameOptions,
		openSearchBestOptionModal,
		goToTelehealthProfessionalSelection,
		goToNextStep,
		isLoadingTelehealthMostRecentDate,
	} = useHealthProfessionalSelection({handleNextStep});

	if (isLoading) {
		return (
			<BookingLoadingState
				showHeader={false}
				pageTitle={bookHealth}
				loadingText={loadingState}
			/>
		);
	}

	if (isError) {
		return (
			<BookingErrorState
				showHeader={false}
				pageTitle={bookHealth}
				errorTitle={loadingError}
				handleRefresh={refetch}
			/>
		);
	}

	if (showNotFoundState) {
		return (
			<HealthProfessionalSelectionNotFoundState
				dataTagId={FinishWithoutCompleteFlowEnum.SEM_PROFISSIONAL_DISPONIVEL}
			/>
		);
	}

	return (
		<Fragment>
			{showSelectedDateProfessionalGrid ? (
				<HealthSelectedDateProfessionalList
					handleSelectHour={handleSelectHour}
					handleClearShiftAndSearch={handleClearShiftAndSearch}
					filteredProvidersNameOptions={filteredProvidersNameOptions}
				/>
			) : (
				<HealthNearestDateProfessionalList
					handleSelectHour={handleSelectHour}
					handleClearShiftAndSearch={handleClearShiftAndSearch}
					availableDates={availableDates ?? []}
					filteredProvidersNameOptions={filteredProvidersNameOptions}
				/>
			)}

			<AlertModal
				headerTitle={searchBestOptionModal.headerTitle}
				title={searchBestOptionModal.title}
				variant="info"
				headerDataTagId={AppointmentBookingEnum.VISUALIZOU_MODAL_PRESENCIAL_AO_DIGITAL}
				description={searchBestOptionModal.description}
				open={openSearchBestOptionModal}
				disableClose
				footerContent={
					<AlertActions
						primaryText={searchBestOptionModal.primary}
						dataTagId={
							AppointmentBookingEnum.CLICK_NAVEGAR_TELEMEDICINA_PRESENCIAL_AO_DIGITAL
						}
						secondaryBtnDataTagId={
							AppointmentBookingEnum.CLICK_MANTER_AGENDAMENTO_PRESENCIAL_AO_DIGITAL
						}
						secondaryText={searchBestOptionModal.secondary}
						primaryAction={goToTelehealthProfessionalSelection}
						secondaryAction={goToNextStep}
						flexDirection="column-reverse"
					/>
				}
			/>

			<PendingDialog
				open={isLoadingTelehealthMostRecentDate}
				text={searchBestOptionModal.loading}
			/>
		</Fragment>
	);
}
